import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonInput, IonItem, IonModal, IonTitle, IonToolbar } from "@ionic/react"
import { useAppDispatch, useAppSelector } from "../../../data/redux/hooks"
import { Department, EditDepartmentFormData } from "../../../models/companyModels";
import { editDepartment } from "../../../data/redux/companySlice";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { useEffect } from "react";

interface EditDepartmentModalProps {
    isOpen: boolean,
    setIsOpen: (isOpen: boolean) => void,
    selectedDepartment?: Department
}

const EditDepartmentModal: React.FC<EditDepartmentModalProps> = ({ isOpen, setIsOpen, selectedDepartment }: EditDepartmentModalProps) => {
    const dispatch = useAppDispatch();
    const { company } = useAppSelector((state) => state.company)
    const { control, handleSubmit, formState: { errors }, reset } = useForm<EditDepartmentFormData>({
        mode: "onTouched",
        reValidateMode: "onChange",
        defaultValues: { name: selectedDepartment?.name }
    });

    const onSubmit: SubmitHandler<EditDepartmentFormData> = (formData) => {
        let data = {
            name: formData.name,
            company_id: company?.company.id,
            id: selectedDepartment?.id
        }
        dispatch(editDepartment(data))
        setIsOpen(false);
    }

    useEffect(() => {
        if (selectedDepartment && isOpen) {
            reset({ name: selectedDepartment.name })
        }
    }, [selectedDepartment, isOpen, reset])


    return (
        <IonModal isOpen={isOpen} onDidDismiss={() => { setIsOpen(false); reset({ name: "" }) }}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Abteilung bearbeiten</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
                        <IonItem className="centeredPreAuthInput">
                            <Controller
                                name="name"
                                control={control}
                                rules={{
                                    required: { value: true, message: "Bitte geben Sie einen Namen an" },
                                }}

                                render={({ field }) => <IonInput
                                    label="Name"
                                    labelPlacement="floating"
                                    type="text"
                                    aria-invalid={!!errors.name}
                                    value={field.value}
                                    /* @ts-ignore */
                                    onIonInput={(e) => field.onChange(e.detail.value)}
                                    onIonBlur={() => field.onBlur()}
                                />}
                            />
                        </IonItem>
                        <div className="errorText">{errors.name?.message}</div>
                </form>
            </IonContent>
            <IonFooter >
                <IonToolbar>
                    <IonButtons slot="end">
                        <IonButton role="cancel" onClick={() => setIsOpen(false)}>Abbrechen</IonButton>
                        <IonButton fill="solid" color="primary" type="submit" onClick={handleSubmit(onSubmit)}>speichern</IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonFooter>
        </IonModal>
    )
}

export default EditDepartmentModal;